import React from 'react';
import Swal from "sweetalert2";

//import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import { Col } from "reactstrap";


export default function ImageFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    //const { t } = useTranslation();
    //const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register } = formManager;


    const [shouldRender, setShouldRender] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                if (args.trigger === "loadSiteLogo") {
                    data.renderValue = modelFctManager.appProps?.getSite()?.avatar || data.src;
                    setShouldRender(!shouldRender);
                }
                else {
                    modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                }
            });
        }

        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };

    register(bindPropResult);

    //var disabled = ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false));


    function loadImage(imgPath) {
        if (!imgPath?.startsWith) {
            //console.log("No imgpath");
            return "";
        }

        if (imgPath.startsWith("draw:") || imgPath.startsWith("mipmap:")) {
            var path = data.tag || imgPath;
            if (path.endsWith(".jpg") || path.endsWith(".png")) {
                return require("assets/img/res/" + (data.tag || imgPath)/*imgPath*/.replace("draw:", "").replace("mipmap:", ""));//TEMP PATCH : supprime l'extension pour compatibilité android
            }
            else {
                return require("assets/img/res/" + (data.tag || imgPath)/*imgPath*/.replace("draw:", "").replace("mipmap:", "") + ".png");//TEMP PATCH : supprime l'extension pour compatibilité android
            }
        }
        /*else if (imgPath.startsWith("../api")) {

        }*/
        else {
            if (imgPath.startsWith("/")) {
                //TODO : load équivalent web
                var site = modelFctManager.appProps?.getSite();
                if (!(site.files?.length)) {
                    /*commonFunc.getMethod("../api/site/GetSiteFiles", { filetypeID: "SITE", bindID: site.idSite, fileID: -1 }).then((response) => {
                        var dataFiles = response.data;

                        if (dataFiles.isSuccess) {
                            site.files = dataFiles.result;
                            site.files.filter((file => file.))
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                html: "Echec de récupération du fichier équivalent<br/>" + dataFiles.errorMessage
                            });
                        }
                    });*/

                    imgPath = "";//Loading
                    modelFctManager.addWaitingFileCpt(data);
                }
                else {
                    var siteFile = site.files.filter((file => file.name === imgPath.replace("/", "")));
                    if (siteFile?.length) {
                        var dt = siteFile[0];
                        const file = {
                            fileId: dt.idFile,
                            fileName: dt.name,
                            container: dt.rootContainer,
                            etag: dt.etag,
                            accessToken: dt.absoluteUri,
                            newWindow: false
                        };
                        imgPath = "../api/data/DownloadFileByUri?" + commonFunc.toParams(file);
                    }
                    else {
                        imgPath = "";//Not Found
                    }
                }
            }
        }
        return imgPath;
    }

    var imageClass = "m-1";
    //var btnSupClass = "";
    var imageStyle = {};
    var imageContainerStyle = {};
    var frameClass = "";
    var frameStyle = {};
    var titleWidthClass = "";
    var titleWidthStyle = {};
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }
    //if (commonFunc.isBlank(data.title) && (data.children == null || data.children.length <= 1)) btnSupClass += " btn-icon ";

    var imageDisplayConfig = { width: "160px", height: "160px" };

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_image");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            //btnClass += supBoxSize;
        }

        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        Object.assign(frameStyle, modelFctManager.manageMargin(design, frameClass));

        if (design.elevation) {
            frameStyle.boxShadow = design.elevation + " " + design.elevation + " 5px rgba(0,0,0,.15)";
        }

        if (design.height) frameStyle.height = design.height;
        if (design.width) frameStyle.width = design.width;

        if (design.margin) {
            frameStyle.margin = design.margin;
            frameClass = frameClass.replace("m-1", "");
        }
        if (design.marginTop) {
            if (design.marginTop.indexOf("px") >= 0) {
                frameStyle.marginTop = design.marginTop;
            }
            else {
                //btnSupClass += design.marginTop;
            }
        }

        if (design.fontColor) titleWidthStyle.color = modelFctManager.getRgbaFromHex(design.fontColor);
        if (design.fontSize) titleWidthStyle.fontSize = design.fontSize;
        if (design.fontStyle) {
            if (design.fontStyle.indexOf("bold") >= 0) titleWidthStyle.fontWeight = "bold";
            if (design.fontStyle.indexOf("italic") >= 0) titleWidthStyle.fontStyle = "italic";
        }

        if (design.alignment) {
            var split = design.alignment.split("|");
            split.forEach((part) => {
                titleWidthClass += " text-" + part.replace("left", "start").replace("right", "end");
                titleWidthClass = titleWidthClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }

        if (design.size != null) {
            switch (design.size) {
                case 0:
                    delete imageDisplayConfig.width;
                    imageDisplayConfig.height = "100%";
                    imageContainerStyle.height = "100%";
                    imageContainerStyle.textAlign = "center";
                    imageContainerStyle.justifyItems = "center";
                    break;
                case 1:
                    //imageDisplayConfig.height = "100%";
                    imageContainerStyle.height = "100%";
                    imageContainerStyle.alignContent = "center";
                    imageContainerStyle.justifyItems = "center";
                    break;
                case 2:
                    //delete imageDisplayConfig.width;
                    //imageDisplayConfig.height = "100%";
                    imageContainerStyle.height = "100%";
                    imageContainerStyle.alignContent = "center";
                    break;
                default:
                    imageDisplayConfig.width = design.size + "px";
                    imageDisplayConfig.height = design.size + "px";
                    break;
            }
        }
    }

    var imgPath = (data.renderValue || data.defaultValue || data.value || data.src);

    var baseForm = <div style={imageContainerStyle}>
        <div className={titleWidthClass} style={titleWidthStyle}>{data.title}</div>
        <img alt="" className={imageClass} style={{ ...imageStyle, ...imageDisplayConfig }} src={loadImage(imgPath)}></img>
    </div>;
    return <Col data-name="ImageFrag" data-element={data.objType} xs="auto" className={` ${frameClass} ${parentProps.parentData.customDesign && parentProps.parentData.customDesign.design && parentProps.parentData.customDesign.design.spacing ? "" : "p-0"}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageopacity={frameStyle.alpha || null}>{baseForm}</Col>;//align-self-center
}